import Splide from '@splidejs/splide';

const EL = '.js-CalendarSlider'
const ISDESKTOP = window.matchMedia("only screen and (min-width: 1024px)").matches

if(ISDESKTOP && document.querySelector(EL)){
  new Splide(EL, {
    autoWidth: true,
    gap: 20,
    omitEnd: true,
    focus: 0,
    arrowPath: 'm5.364 10.727.975-.975L2.647 6.06h8.08V4.667h-8.08L6.339.975 5.364 0 .001 5.363Z',
    pagination: false,
    updateOnMove: true
  }).mount();
}
